export default __webpack_public_path__ + "static/media/screenshot1_sm.1eb23e2e.jpg";